<div class="d-flex flex-column flex-lg-row gap-3 justify-content-center">
  <div class="container-list-videos rounded w-100">
    <div class="container-list-videos__title p-4 d-flex align-items-center justify-content-between">
      <span class="fs-5 bold">{{profesional.title}}</span>
      <span>{{videos?.length}} videos</span>
    </div>
    <div class="container-list-videos__content d-flex flex-column">
      <ng-container *ngFor="let video of videos; trackBy: trackByVideo">
        <div class="d-flex flex-column flex-sm-row px-4 py-2 align-items-center gap-3 pointer" 
             [class.selected]="video.selected" 
             (click)="changeVideo(video)" style="z-index: 1;">
          <iframe 
            [src]="video.safeUrl"
            width="140" 
            height="100" 
            frameborder="0" 
            allow="autoplay; fullscreen; picture-in-picture" 
            allowfullscreen
            class="video-thumbnail">
          </iframe>
          <div>
            <div>
              <span class="fs-7 bold" [class.text-white]="video.selected">{{ video.title }}</span>
            </div>
            <div class="d-flex align-items-start gap-2">
              <img [src]="video.selected ? 'assets/svg/icon-user-white.svg' : 'assets/svg/icon-user.svg'" alt="icon-user.svg">
              <span class="fs-7 regular" [class.text-white]="video.selected">{{ video.nameUser }}</span>
            </div>
            <div class="d-flex align-items-center gap-2">
              <img [src]="video.selected ? 'assets/svg/icon-date-white.svg' : 'assets/svg/icon-date.svg'" alt="icon-date.svg">
              <span class="fs-7 regular" [class.text-white]="video.selected">{{ video.date }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div>
    <iframe 
    [src]="videoCurrent"
        width="800" 
        height="450" 
        frameborder="0" 
        allow="autoplay; fullscreen; picture-in-picture" 
        allowfullscreen
        class="video-current">
    </iframe>
  </div>
</div>